import { Action } from '@ngrx/store';
import { Destination } from '@app/models';

export enum DestinationActionTypes {
  Load = '[Destination] Load',
  LoadSuccess = '[Destination] Load Success',
  LoadFail = '[Destination] Load Fail',
  AddPicture = '[Destination] Add picture',
  Create = '[API] Create destination ',
  CreateSuccess = '[API] Create destination success',
  CreateFail = '[API] Create destination fail',
  DestinationUpdate = '[API] Update destination ',
  DestinationFail = '[API] Update destination fail',
  DestinationSuccess = '[API] Update destination success',
  AddAll = '[destination] Add all',
  AddOne = '[destination] Add one',
  RemoveOne = '[destination] remove∫ one',
  Update = '[API] update destination ',
  UpdateSuccess = '[Destination]  update Destination success',
  UpdateFail = '[Destination]  update Destination fail',
  Delete = '[API] Delete destination ',
  DeleteSuccess = '[Destination]  Delete Destination success',
  DeleteFail = '[Destination]  Delete Destination fail'
}

export class Load implements Action {
  readonly type = DestinationActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = DestinationActionTypes.LoadSuccess;
  constructor(public destinations: Destination[]) {}
}

export class LoadFail implements Action {
  readonly type = DestinationActionTypes.LoadFail;
  constructor(public error: any) {}
}
export class Create implements Action {
  readonly type = DestinationActionTypes.Create;
  constructor(public destinations: Destination) {}
}

export class CreateSuccess implements Action {
  readonly type = DestinationActionTypes.CreateSuccess;
  constructor(public destinations: Destination) {}
}

export class CreateFail implements Action {
  readonly type = DestinationActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = DestinationActionTypes.AddAll;
  constructor(public destination: Destination[]) {}
}

export class AddOne implements Action {
  readonly type = DestinationActionTypes.AddOne;
  constructor(public destination: Destination) {}
}

export class Delete implements Action {
  readonly type = DestinationActionTypes.Delete;
  constructor(public id: number) {}
}
export class DeleteFail implements Action {
  readonly type = DestinationActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export class DeleteSuccess implements Action {
  readonly type = DestinationActionTypes.DeleteSuccess;
  constructor(public data: any) {}
}

export class Update implements Action {
  readonly type = DestinationActionTypes.Update;
  constructor(public id: number, public destination: any) {}
}
export class UpdateFail implements Action {
  readonly type = DestinationActionTypes.UpdateFail;
  constructor(public error: any) {}
}
export class RemoveOne implements Action {
  readonly type = DestinationActionTypes.RemoveOne;
  constructor(public id: string) {}
}

export class UpdateSuccess implements Action {
  readonly type = DestinationActionTypes.UpdateSuccess;
  constructor(public data: any) {}
}

export type DestinationActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddAll
  | AddOne
  | Delete
  | DeleteFail
  | DeleteSuccess
  | Update
  | UpdateFail
  | RemoveOne
  | UpdateSuccess;
